@if (!showMaintenanceMessage()) {
  <router-outlet
  ></router-outlet>
} @else {
  <div class="maintenance-message">
    <img src="../assets/images/cotecna-eye-icon.png" />
    <div class="text-container">
      <span class="primary-text"
        >We are currently working to make Cotecna Eye even better. It will be
        back available in 1 hour maximum.</span
        >
        <br />
        <span class="secondary-text">Stay tuned!</span>
      </div>
    </div>
  }

